import { Controller } from "@hotwired/stimulus";

// data-controller="utility-page-transition"
export default class PageTransitionController extends Controller {
  connect() {
    requestAnimationFrame(() => {
      this.element.classList.remove("opacity-0", "translate-y-1");
    });
  }
}
